import { Backdrop } from "@mui/material";
import { motion } from "framer-motion";
import { Logo } from "../../../../svg/Logo";

export default function BackdropMeepl({
  open = false,
  dark = false,
  circleSize = 80,
  logoHeight = 40,
  logoWidth = 50,
}) {
  return (
    <Backdrop
      sx={{
        position: "absolute",
        inset: 0, 
        backgroundColor: dark
          ? "rgba(0, 0, 0, 0.5)" // 🔥 DARK MODE
          : "rgba(255, 255, 255, 0.6)", // 🔥 LIGHT MODE
        backdropFilter: dark ? "none" : "blur(2px)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={open}
    >
      <motion.div
        style={{
          height: circleSize,
          width: circleSize,
          borderRadius: "50%",
          background: dark
            ? "rgba(255, 255, 255, 0.42)"
            : "rgba(0, 0, 0, 0.32)",
          backdropFilter: dark ? "none" : "blur(8px)",
          boxShadow: dark
            ? "0 0 18px rgba(255,255,255,0.1)"
            : "0 4px 12px rgba(0,0,0,0.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        animate={{
          scale: [1, 1.1, 1],
          boxShadow: dark
            ? [
                "0 0 10px rgba(255,255,255,0.3)",
                "0 0 20px rgba(255,255,255,0.6)",
                "0 0 10px rgba(255,255,255,0.3)",
              ]
            : [
                "0 0 10px rgba(255,255,255,0.2)",
                "0 0 20px rgba(255,255,255,0.5)",
                "0 0 10px rgba(255,255,255,0.2)",
              ],
        }}
        transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            opacity: [1, 0.8, 1],
          }}
          transition={{
            duration: 1.6,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            height: logoHeight,
            width: logoWidth,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Logo />
        </motion.div>
      </motion.div>
    </Backdrop>
  );
}

// components={{
//   Overlay: () => null,             // remove default dark overlay
//   OverlayLoading: () => <BackdropMeepl open={true} />,
// }}
